<template>
	<div class="main-contents">
		<div class="tit">파트너사 담당자 승인관리</div>
		<div class="search-box interval">
			<SelectComp list = "01:승인,02:미승인,11:반려" :isAll="true" title="담당자 승인여부" v-model="srchFilter.apprDiv"/>
			<nbsp/>
			<SelectComp list="corp:파트너사명,mber:담당자명,hpNo:연락처" v-model="srchFilter.srchTxtDiv" @change="srchTxtPlaceholder = $event.target.selectedOptions[0].label"/>
			<InputComp v-model="srchFilter.srchTxt" :placeholder="srchTxtPlaceholder" @keyup.enter="getSupplyCorpInfoList('1')" />
			<img class="search_btn" src="/images/admin/search_btn.png" alt="검색버튼" @click="getSupplyCorpInfoList('1')" />
		</div>
		<!-- 전체프로젝트 리스트 -->
		<div class="Board type3">
			<table class="Board_type3 admin">
				<colgroup>
					<col width="5%">
					<col width="13%">
					<col width="13%">
					<col width="16%">
					<col width="30%">
					<col width="13%">
					<col width="10%">
				</colgroup> 
				<thead>
					<tr>
						<th>NO</th>
						<th>담당자명</th>
						<th>아이디</th>
						<th>연락처</th>
						<th>기업명</th>
						<th>회원가입일</th>
						<th>관리자 승인</th>
					</tr>
				</thead>
				<tbody v-if="supGmgList.length > 0">
					<tr v-for="(row, rowIdx) in supGmgList" :key="rowIdx" :class="row.mberStatusCd == '02' ? 'new' : ''">
						<!-- <td class="score"><div class="new" v-if="row.mberStatusCd == '02'">new</div>{{rowIdx + 1}}</td> -->
						<td class="score"><div class="new" v-if="row.mberStatusCd == '02'">new</div>{{ (pageInfo.pageIndex - 1) * pageInfo.pageUnit + (rowIdx + 1)}}</td>
						<td class="score name" @click="openPopup(row.mberSeq)">{{row.mberNm}} &#9654;</td>
						<td class="score">{{row.loginId}}</td>
						<td class="score">{{row.mberHpNo | phone}}</td>
						<td class="score">{{row.corpNm}}</td>
						<td class="score">{{row.regYmd | date('yyyy.MM.dd')}}</td>
						<td class="score resume" :class="row.mberStatusCd == '01' ? 'apvl' : 'resume'">
							<div v-if="row.mberStatusCd == '01'">승인</div>
							<div v-else-if="row.mberStatusCd == '11'" class="reject">반려</div>
							<div v-else class="btn rq" @click="scoAppr(rowIdx)">승인하기 &#9654;</div>
						</td>
					</tr>
				</tbody>
				<tbody v-else>
					<!-- 관련내용 없을 경우 -->
					<tr>
						<td colspan="9" class="none">등록된 파트너사 담당 회원이 없습니다.</td>
					</tr>
				</tbody>
			</table>
		</div>

		<!-- 페이징부분 -->
		<pagingComp :pageInfo="pageInfo" @page-click="goPage"/>
	</div>
</template>

<script>
import pagingComp from '@/components/PagingComp.vue';

export default {
	data() {
		return {
			srchFilter : {
				apprDiv : '',
				srchTxtDiv : 'corp',
				pageIndex : 1,
			},

			supGmgList : [],

			pageInfo : {},

			srchTxtPlaceholder : '파트너사명'
		}
	},

	components : {
		pagingComp
	},
	beforeMount() {
		var keys = Object.keys(this.srchFilter);
		for(var key in this.$route.params){
			if(keys.indexOf(key) >= 0){
				this.srchFilter[key] = this.$route.params[key];
			}
		}
		this.getSupplyCorpInfoList();
	},

	methods : {
		getSupplyCorpInfoList(div) {
			var param = this.srchFilter
			param.pageUnit = '25';
			param.pageSize = '10';
			if(div) param.pageIndex = 1;

			this.$.httpPost('/api/mem/adm/sco/selectScoGmgInfoList', param)
				.then(res => {
					//console.log('selectScoGmgInfoList RESULT', res);

					this.supGmgList = res.data.supGmgList;
					this.pageInfo = res.data.pageInfo;
				}).catch(this.$.httpErrorCommon);
		},

		openPopup(seq) {
			var param = {};
			param.div = 'sco';
			param.reqMberSeq = seq;

			this.$.popup('/adm/mem/MEM923P02', param);
			
		},

		// 파트너사 담당자 승인하기
		scoAppr(idx) {
			var obj =  this.supGmgList[idx];
			var params = {
				mberNm:obj.mberNm,
				loginId:obj.loginId,
				corpSeq:obj.corpSeq, 
				corpNm:obj.corpNm,
				corpDivCd:'20'
			}
			
			// this.$.popup('/adm/mem/MEM930P01', {mberNm:obj.mberNm, loginId:obj.loginId, corpNm:obj.corpNm})
			this.$.popup('/adm/mem/MEM924P01', params)
				.then(res => {
					if(res) {
						var param = {
							scoMberSeq : obj.mberSeq,
							mberStatusCd : res.mberStatusCd,
							corpSeq : res.corpSeq
						};

						this.$.httpPost('/api/mem/adm/sco/admScoMberAppr', param)
							.then(() => {
								this.getSupplyCorpInfoList();
							}).catch(this.$.httpErrorCommon);
					}
				})
		},

		// 페이징 이동
		goPage(page) {
			this.srchFilter.pageIndex = page;
			this.getSupplyCorpInfoList();
		},
	}
}
</script>